<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import List from "../../../components/list";
import Loading from "@/components/c-loading";
import { bookingpaymentService } from "../../../services/bookingservice/bookingpayment.service";
import i18n from "../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Booking Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Booking",
      breadCrumb: {},
      currency: "",
      project: 0,

      bookingData: null,
      bankAccountData: {},
      customerData: {},
      templeteData: {},
      projectData: {},
      discountTypeData: {},
      accountTenderData: {},
      accountBookingData: {},
      propertyData: {},
      sellerData: {},
      currencyData: {},
      commissionTypeData: {},
      paymentMethodData: {},
      accountCommissionExpenseData: {},
      accountCommissionPaidData: {},
      dataDiscountText: '',
      dataProject: 0,
      dataLastProject: 0,
      propertySelected: {},
      dataBookingPayments: {},
      user: JSON.parse(localStorage.getItem('user')),
      seller: JSON.parse(localStorage.getItem('seller')),

      dataCode: '',
      dataCustomer: 0,
      dataTemplate: 0,
      dataPaymentAccount: 0,
      dataBankAccount: 0,
      dataCurrency: 0,
      dataBookingAccount: 0,
      dataProperty: 0,
      dataAmount: 0,
      dataPaymentMethod: 1,
      dataDiscount: 0,
      dataDiscountType: 0,
      dataSalePrice: 0,
      dataExpireDate: this.$moment().add(7, 'days').format('YYYY-MM-DD'),
      dataBookingAmount: 0,
      dataSaleUser: 0,
      dataCommission: 0,
      dataCommissionAmount: 0,
      dataCommissionExpenseAccount: 0,
      dataCommissionPaidAccount: 0,
      dataNotation: '',
      dataDoc: [],
      dataDate: this.$moment().clone().format('YYYY-MM-DD'),

    };
  },
  mounted() {
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      bookingpaymentService.getListByBooking(id)
        .then(response => {

          this.fetchingStats = true;
          if(response.data) {
            this.dataBookingPayments = response;
          }
        
        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
          });

        }
      }); 
    },
    
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, {
        text: $t('booking.new'),
        active: true
      }]" :title="this.isAdd ? $t('booking.new') : $t('booking.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, this.breadCrumb]" :title="this.isAdd ? $t('booking.new') : $t('booking.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <h4 class="card-title">{{$t('booking.booking-history')}}</h4>
              </div>
              <div class="row">
                <List v-bind:dataList="dataBookingPayments" 
                  v-bind:showNo="false"
                  v-bind:more="{
                    sub: [{
                      name: 'payment.receipt', icon:'bx bx-receipt', link: 'booking-payment-receipt', column: 'id', target: '_blank'
                    }]

                  }"
                  v-bind:filter="{}"
                  v-bind:updating="fetchingStats" 
                  v-bind:navigate="pageNavigate"
                  v-bind:formats="[{name: 'pay_date', type: 'date'}, {name: 'paid', type: 'currency', sign: '$'}]"
                  v-bind:fields="[ `code: ${$t('booking.code')}`, `pay_date: ${$t('general.date')}`, `paid: ${$t('booking.amount')}`]" />
              </div>
          </div>
        </div>
      </div>

      
    </b-form> 

  </Layout>
</template>